<div class="side-bar-box">
  <i
    class="material-icons side-nav-icon app-text-dark"
    style="margin-top:0;"
    data-testid="nav-menu-toggle"
    (click)="onToggleMenu()"
  >menu</i>
</div>
<section class="side-nav-menu" [ngClass]="{ 'side-nav-menu--open': isMenuOpen }">
  <div class="side-nav-title">
    <h1 class="h4 mb-0">MENU</h1>
    <i
      class="material-icons side-nav-icon"
      data-testid="nav-menu-close"
      (click)="onToggleMenu()"
    >close</i>
  </div>
  <div *ngIf="calculationsExposed" class="app-bg-white">
    <app-calculation-exposure></app-calculation-exposure>
  </div>
  <div>
    <div
      *ngFor="let item of menuItems$ | async; let i = index"
      class="side-nav-item"
      [attr.data-testid]="getMenuItemTestId(item, i)"
      (click)="onSelectAuxiliaryModalRoute(item)">
      {{ item.description }}
    </div>
    <div
      *ngIf="(!calculationsExposed && !isProduction) || isQa || (isSalesManager$ | async) || (isAdmin$ | async)"
      class="side-nav-item"
      data-testid="nav-sidebar-expose-calculations"
      (click)="onSelectExposeCalculations()">
      Expose Calculations
    </div>
    <div
      *ngIf="(!calculationsExposed && !isProduction) || isQa || (isSalesManager$ | async) || (isAdmin$ | async)"
      class="side-nav-item"
      data-testid="nav-sidebar-report-bug"
      (click)="onReportBug()">
      Report a Bug
    </div>
  </div>
</section>
